<template>
  <div class="verify-advice">
    <div class="field-list">
      <div class="count">
        <span class="color-Gray_75">选择了{{ tempData.acceptFillCids.length }}个字段</span>
        <span class="btn-change pLeft16" @click="selectField">
          <i class="el-icon-edit"></i>
          修改字段
        </span>
      </div>
      <el-tree
        v-show="tempData.acceptFillCids.length"
        :data="tempData.acceptFillCids"
        :props="{ children: 'subList' }"
        :expand-on-click-node="false"
        draggable
        :allow-drop="allowDrop"
        :allow-drag="allowDrag"
      >
        <div class="field-item" slot-scope="{ node, data }">
          <span v-tip class="name">
            <svg-icon
              v-if="node.level === 1 && !['verifyComments', 'verifySign'].includes(data.cid)"
              class="pointer"
              icon-class="svgo_drag"
              style="padding-right: 6px;"
            ></svg-icon>
            {{ fieldsInfoMap[data.cid] || "字段已删除" }}
          </span>
          <div class="actionList pointer">
            <span :class="{ active: data.type == 'R' }" @click="data.type = 'R'">
              {{ ["verifyComments", "verifySign"].includes(data.cid) ? "隐藏" : "只读" }}
            </span>
            <span :class="{ active: data.type == 'W' }" @click="data.type = 'W'">
              填写
            </span>
            <span :class="{ active: data.type == 'H' }" @click="data.type = 'H'">
              必填
            </span>
          </div>
          <i
            v-if="!['verifyComments', 'verifySign'].includes(data.cid)"
            class="el-icon-delete-solid pointer"
            @click="removeField(node, data)"
          ></i>
        </div>
      </el-tree>
    </div>
    <select-fields
      ref="selectFields"
      :key="sheetId"
      :control-mapper="controlMapper"
      :level="0"
      @submit="updateFillFields"
      from="userVerify"
    ></select-fields>
  </div>
</template>
<script>
import SelectFields from "@/views/Company/Manage/Project/TaskTemplate/EditDialog/SelectFields"
import { bfs } from "@/utils/algorithm"
export default {
  name: "verifyAdvice",
  components: { SelectFields },
  props: {
    sheetId: String,
    disabled: Boolean,
    tempData: Object,
    fieldsInfoMap: Object
  },
  computed: {
    hasSelected() {
      let selected = []
      bfs({
        arr: this.tempData.acceptFillCids || [],
        childFuc: row => row.subList,
        cbk: row => {
          if (row._parent) selected.push(row._parent.cid + "_" + row.cid)
          else if (!["verifyComments", "verifySign"].includes(row.cid)) selected.push(row.cid)
        }
      })
      return selected
    }
  },
  methods: {
    selectField() {
      this.$refs.selectFields.open(this.sheetId, this.hasSelected)
    },
    removeField(node, curRow) {
      const parent = node.parent
      const children = parent.data.subList || parent.data
      const index = children.findIndex(d => d.cid === curRow.cid)
      children.splice(index, 1)
    },
    allowDrop(draggingNode, dropNode, type) {
      return (
        dropNode.level === 1 &&
        ["next", "prev"].includes(type) &&
        !["verifyComments", "verifySign"].includes(dropNode.data.cid)
      )
    },
    allowDrag(draggingNode) {
      // 允许第一级拖拽排序, 不允许拖拽审批意见与审批签名
      return (
        draggingNode.level === 1 &&
        !["verifyComments", "verifySign"].includes(draggingNode.data.cid)
      )
    },
    controlMapper(control) {
      // 暂不需要限制主从关联,限制关联表单条
      if (control._type == "ref") {
        if (control.oneFlag) {
          control.isLeaf = true
        }
      }
      return control
    },
    updateFillFields(cids) {
      let rowStateMap = {}
      bfs({
        arr: this.tempData.acceptFillCids || [],
        childFuc: row => row.subList,
        cbk: row => {
          let { cid, _parent } = row
          let curCid = (_parent ? _parent._prefix : "") + cid
          row._prefix = curCid + "_"
          rowStateMap[curCid] = row.type
        }
      })
      let rowMap = {}
      cids
        .sort((a, b) => a.length - b.length)
        .forEach(cidStr => {
          let index = cidStr.lastIndexOf("_")
          if (index < 0) {
            rowMap[cidStr] = { cid: cidStr, type: rowStateMap[cidStr] || "W", subList: [] }
            return
          }
          let cid = cidStr.slice(index + 1)
          let prefix = cidStr.slice(0, index)
          let row = {
            cid: cid,
            type: rowStateMap[cidStr] || "W",
            subList: []
          }
          rowMap[cidStr] = row
          rowMap[prefix].subList.push(row)
        })
      this.tempData.acceptFillCids = [
        { cid: "verifyComments", type: rowStateMap["verifyComments"] || "W", subList: [] },
        { cid: "verifySign", type: rowStateMap["verifySign"] || "W", subList: [] }
      ].concat(Object.keys(rowMap).map(cid => rowMap[cid]))
    }
  }
}
</script>

<style lang="scss" scoped>
.verify-advice {
  margin-top: 10px;
  .field-list {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 13px;
    .el-tree {
      position: relative;
      left: -24px;
      margin-top: 10px;
    }
    ::v-deep {
      .el-tree-node {
        &:focus .el-tree-node__content {
          background-color: unset;
        }
        .el-tree-node__content {
          height: 36px;
          margin-bottom: 10px;
          &:hover {
            background-color: unset;
          }
        }
      }
    }
    .btn-change {
      color: #2196f3;
      cursor: pointer;
    }
    .field-item {
      flex: 1;
      display: flex;
      align-items: center;
      height: 36px;
      .name {
        flex: 1 1;
        padding: 0 12px;
        background: #f8f8f8;
        color: #333;
        border-radius: 4px;
        height: 36px;
        line-height: 36px;
      }
      .actionList {
        width: 160px;
        display: flex;
        margin: 0 10px 0 7px;
        box-sizing: border-box;
        background: #f8f8f8;
        span {
          color: #757575;
          line-height: 36px;
          display: inline-block;
          text-align: center;
          flex: 1 1;
          &.active {
            color: #2196f3;
          }
        }
      }
      .el-icon-delete-solid {
        padding: 3px;
        position: absolute;
        right: -10px;
        &:hover {
          color: #f44336;
        }
      }
    }
  }
}
</style>
